module.exports = __webpack_public_path__ + "media/images/default/pages/about/clinic-5-d07ff21d206f7d1fc350453bb363cc51.jpeg";